// src/pages/Login/AMTPLLogin.js
import React from 'react';
import Login from '../../components/Login/Login';

const AMTPLLogin = () => {
  return <Login role="amtpl" />;
};

export default AMTPLLogin;
